import * as actionTypes from './actionTypes';
import * as actions from './index';
import * as ConfigTypes from 'config/ConfigTypes';
import { getStation } from "helpers/AppHelper";
import { verifyGrantingList, verifyGranting } from "helpers/GrantingHelper";
import { checkAndChangeFields } from "helpers/SearchHelper";

export const getLane = ({ laneId, isExtra }) => {
    return (dispatch, getState) => {
        let trailer;
        if (laneId) {
            window.flow.getDistprojectById(laneId)
                .then(res => {
                    console.log("LOGS: getLane res", res);
                    if (res && res.data && res.data.clips
                        && res.data.clips.elements && res.data.clips.elements[0]) {
                        trailer = { ...res.data.clips.elements[0].data, laneId: laneId };
                    }
                    let obj = {};
                    if (isExtra) obj.currentTrailer = trailer;
                    else obj[`lane${laneId}Trailer`] = trailer;
                    dispatch(actions.updateMediaObjects(obj));
                })
                .catch(err => {
                    console.log("LOGs: getLane err", err);
                })
        }
    }
}

export const filterInternalOnly = ({ entry }) => {
    if (entry.mediafiles && entry.mediafiles.elements && entry.mediafiles.elements.length) {
        let newElements = entry.mediafiles.elements.filter(el => {
            if (el.data && el.data.tags && el.data.tags.includes("internalonly")) {
                //console.log("LOGS: LAMTEST el.data.tags", el.data.tags);
                return false;
            }
            return true;
        });
        entry.mediafiles.elements = newElements;
    }
    return entry;
}

export const filterInternalOnlyList = ({ list }) => {
    list = list.map(item => filterInternalOnly({ entry: item }));
    return list;
}

export const getItemList = (res) => {
    let itemlist = [];
    if (res && res.children && res.children.length) {
        res.children.forEach(item => {
            if (item.project && item.project.data && item.project.data.clips
                && item.project.data.clips.elements && item.project.data.clips.elements.length) {
                let elements = item.project.data.clips.elements;
                elements = elements.map(el => {
                    return { ...el.data, manifest: item.project.data.id };
                });
                //elements = verifyGrantingList({ elements, cfName: "items" });
                itemlist = [...itemlist, ...elements];
                //console.log("LOGS: LAMTEST itemlist", itemlist);
            }
        })
    }

    itemlist = filterInternalOnlyList({ list: itemlist });
    return itemlist;
}


export const getObjectList = (res) => {
    let objectlist = [];
    if (res && res.project && res.project.data && res.project.data.clips
        && res.project.data.clips.elements && res.project.data.clips.elements.length
    ) {
        objectlist = res.project.data.clips.elements.map(item => {
            return { ...item.data }
        })
    }

    objectlist = filterInternalOnlyList({ list: objectlist });
    return objectlist;
}

export const getUpdatedObject = ({ updated, res, isHome }) => {
    let elements = [];
    if (res.children && res.children[0] && res.children[0].project
        && res.children[0].project.data
        && res.children[0].project.data.clips
        && res.children[0].project.data.clips.elements
        && res.children[0].project.data.clips.elements.length
    ) {
        elements = [...res.children[0].project.data.clips.elements];
        updated.currentWork[`clips`] = { elements }
    }
    if (isHome && updated.currentWork
        && updated.currentWork.clips
        && updated.currentWork.clips.elements[0]
        && updated.currentWork.clips.elements[0].data) {
        updated.currentClip = updated.currentWork.clips.elements[0].data;
    }

    //Items
    let itemlist = getItemList(res);
    updated.itemlist = itemlist;
    updated.itemlistOriginal = itemlist;
    updated.itemTotalItems = itemlist.length || 0;

    //Objects
    let objectlist = getObjectList(res);
    updated.objectlist = objectlist;
    updated.objectlistOriginal = objectlist;
    updated.objectTotalItems = objectlist.length || 0;

    updated.wpView = ConfigTypes.WORK_LIST;
    return updated;
}

export const getObject = ({ objectId }) => {
    let updated = {};
    return async (dispatch) => {
        console.log("LOGS: getObject objectId", objectId);
        const res = await window.flow.sdkGetObject(objectId);
        if (res) {
            console.log("LOGS: getObject res", res);
            //updated.currentClip = { ...res.data };
            let object = filterInternalOnly({ entry: res.data });
            updated.currentClip = { ...object };
            dispatch(actions.updateMediaObjects(updated));
        }
    }
}

export const getObjectdetailsByPriref = ({ prirefId }) => {
    let updated = {};
    return async (dispatch) => {
        console.log("LOGS: getObjectdetailsByPriref  prirefId", prirefId);
        const res = await window.flow.sdkGetObjectByPriref(prirefId);
        if (res) {
            console.log("LOGS: getObjectdetailsByPriref res", res);
            //updated.currentClip = { ...res.data };
            let object = filterInternalOnly({ entry: res.data });
            updated.currentClip = { ...object };
            dispatch(actions.updateMediaObjects(updated));
        }
    }
}

export const getItem = ({ itemId }) => {
    let updated = {};
    return async (dispatch) => {
        console.log("LOGS: getItem itemId", itemId);
        const res = await window.flow.sdkGetItem(itemId);
        console.log("LOGS: getItem res", res);
        if (res) {
            //updated.currentClip = verifyGranting({ el: { ...res.data }, cfName: "items" });
            let item = verifyGranting({ el: { ...res.data }, cfName: "items" });
            item = filterInternalOnly({ entry: item });
            updated.currentClip = { ...item };
            dispatch(actions.updateMediaObjects(updated));
        }
    }
}

export const getItemdetailsByPriref = ({ prirefId }) => {
    let updated = {};
    return async (dispatch) => {
        console.log("LOGS: getItemdetails prirefId", prirefId);
        const res = await window.flow.sdkGetItemByPriref(prirefId);
        console.log("LOGS: getItemdetails res", res);
        if (res) {
            //updated.currentClip = verifyGranting({ el: { ...res.data }, cfName: "items" });
            let item = verifyGranting({ el: { ...res.data }, cfName: "items" });
            item = filterInternalOnly({ entry: item });
            updated.currentClip = { ...item };
            dispatch(actions.updateMediaObjects(updated));
        }
    }
}

export const setCurrentWork = ({ res, isHome, dispatch }) => {
    console.log("LOGS: GETCURRENTWORK res", res);
    if (res && res.project && res.project.data) {
        let manifests = res.children.filter(item => {
            if (item.project && item.project.data && item.project.data.clips
                && item.project.data.clips.elements
                && item.project.data.clips.elements.length) {
                return true;
            }
            return false;
        }).map(item => ({ ...item.project.data.metadata.fields }));
        console.log("LOGS: setCurrentWorkd manifests", manifests);
        let updated = { currentWork: { ...res.project.data, manifests } };
        updated = getUpdatedObject({ updated, res, isHome });
        dispatch(actions.updateMediaObjects(updated));
    }
    dispatch(actions.updateMediaObjects({ loading: false }));
}

export const getWork = ({ workId, isHome = false }) => {
    console.log("LOGS: getWork workId", workId);
    return (dispatch) => {
        dispatch(actions.updateMediaObjects({ loading: true }));
        if (workId) {
            window.flow.sdkGetWerk(workId)
                .then(res => setCurrentWork({ res, isHome, dispatch }))
                .catch(err => {
                    console.log("LOGS: GETWORK err", err);
                    dispatch(actions.updateMediaObjects({ loading: false }));
                })
        }
    }
}

export const getWorkdetailsByPriref = ({ prirefId, isHome = false }) => {
    return (dispatch) => {
        dispatch(actions.updateMediaObjects({ loading: true }));
        if (prirefId) {
            console.log("LOGS: getWorkdetails prirefId", prirefId);
            window.flow.sdkGetWerkByPriref(prirefId)
                .then(res => setCurrentWork({ res, isHome, dispatch }))
                .catch(err => {
                    console.log("LOGS: GETWORK err", err);
                    dispatch(actions.updateMediaObjects({ loading: false }));
                })
        }
    }
}

export const getObjectdetails = ({ prirefId }) => {
    let updated = {};
    return async (dispatch) => {
        console.log("LOGS: getObjectdetails prirefId", prirefId);
        const res = await window.flow.sdkGetObjectByPriref(prirefId);
        if (res) {
            console.log("LOGS: getObjectdetails res", res);
            updated.currentClip = { ...res.data };
            dispatch(actions.updateMediaObjects(updated));
        }
    }
}

export const searchWorks = ({ keyword = '', fields = [], clickPage, isHome = false, showAll = false, restart = false }) => {
    return (dispatch, getState) => {
        let worklist = [];
        let offset = 0;
        let currentPage = getState().media.mediaObjects.workCurrentPage;
        if (clickPage) currentPage = clickPage;
        if (currentPage) offset = (currentPage - 1) * ConfigTypes.LIMIT;

        dispatch(actions.updateMediaObjects({ loading: true }));
        let searchParams = { fields: fields, offset, limit: ConfigTypes.LIMIT };
        if (showAll) {
            searchParams.offset = 0;
            searchParams.limit = 0;
        }
        if (restart) searchParams.offset = 0;

        console.log("LOGS: SEARCHWORKS sdkSearchWerke searchParams", searchParams);
        console.log("LOGS: SEARCHWORKS sdkSearchWerke keyword", keyword);

        searchParams = checkAndChangeFields({ searchParams });
        window.flow.sdkSearchWerke(keyword, searchParams)
            .then((res) => {
                console.log("LOGS: SEARCHWORKS res", res);
                let workTotalItems;
                if (res && res.count) workTotalItems = +res.count;
                let itemsPerPage = ConfigTypes.ITEMS_PER_PAGE;
                let updated = {};
                if (res.count == 0) {
                    updated.worklist = [];
                    updated.workTotalItems = 0;
                    updated.workTotalPages = 1;
                }
                if (res && res.order && res.order.length) {
                    res.order.forEach(item => worklist.push(res.objects.elements[item].data));
                    updated = {
                        worklist: worklist, workLength: res.order.length,
                        workTotalItems, workTotalPages: Math.ceil(workTotalItems / itemsPerPage)
                    }
                    if (showAll) {
                        updated.workCurrentPage = 1;
                        updated.workTotalPages = 1;
                    }
                    if (isHome && worklist[0]) {
                        updated.currentClip = worklist[0];
                        updated.currentWork = worklist[0];
                        updated.cliplist = worklist;
                        updated.workSearch = true;
                    }

                }
                dispatch(actions.updateMediaObjects(updated));
                setTimeout(() => dispatch(actions.updateMediaObjects({ loading: false })), 1000);
            })
            .catch(err => {
                console.log("LOGS: searchWorks SERVER ERROR", err);
                dispatch(actions.updateMediaObjects({ serverError: true }));
            })
    }
}

export const searchObjects = ({ keyword, fields = [], clickPage, isHome = false, showAll = false, restart = false }) => {
    console.log("LOGS: SEARCHOBJECTS searchFullText keyword", keyword);
    console.log("LOGS: SEARCHOBJECTS searchFullText fields", fields);
    return (dispatch, getState) => {
        let offset = 0;
        let currentPage = getState().media.mediaObjects.currentPage;
        if (clickPage) currentPage = clickPage;
        if (currentPage) {
            offset = (currentPage - 1) * ConfigTypes.LIMIT;
        }
        if (fields && !fields.length) {
            let searchField = ConfigTypes.DEFAULT_SEARCH_FIELD;
            if (getState().media.mediaObjects.searchSortCurrent) {
                searchField = getState().media.mediaObjects.searchSortCurrent.name;
            }
            fields.push({ field: searchField, type: 'ORDER', value: ConfigTypes.ASC })
        }
        let cliplist = [];
        dispatch(actions.updateMediaObjects({ loading: true }));
        let searchObj = { offset, limit: ConfigTypes.LIMIT, kaenguruh: 'no', fields: [...fields] };
        if (showAll) {
            searchObj.offset = 0;
            searchObj.limit = 0;
        }
        if (restart) searchObj.offset = 0;
        console.log("LOGS: SEARCHOBJECTS searchObj", searchObj);
        window.flow.sdkSearchObjects(keyword, searchObj)
            .then((res) => {
                console.log("LOGS: SEARCHOBJECTS res", res);
                let totalItems;
                if (res && res.count) totalItems = +res.count;
                console.log("LOGS: totalItems", totalItems);
                let itemsPerPage = ConfigTypes.ITEMS_PER_PAGE;
                let updated = {};
                if (res && +res.count == 0) {
                    updated.cliplist = [];
                    updated.totalItems = 0;
                    updated.totalPages = 1;
                }
                if (res && res.order && res.order.length) {
                    cliplist = res.order.map(element => res.clip.elements[element].data);
                    cliplist = filterInternalOnlyList({ list: cliplist });
                    updated = {
                        cliplist: cliplist,
                        clipLength: res.order.length,
                        totalItems,
                        totalPages: Math.ceil(totalItems / itemsPerPage),
                    }
                    if (showAll) {
                        updated.currentPage = 1;
                        updated.totalPages = 1;
                    }
                    if (isHome && cliplist[0]) {
                        updated.currentClip = cliplist[0];
                    }
                }
                dispatch(actions.updateMediaObjects(updated));
                setTimeout(() => dispatch(actions.updateMediaObjects({ loading: false })), 100);
            })
            .catch(err => {
                console.log("LOGS: searchFullText ERROR", err);
                setTimeout(() => dispatch(actions.updateMediaObjects({ loading: false })), 100);
            })
    }
}

export const getExtraLane = ({ elements }) => {
    let extraLane;
    let stationName = getStation();
    if (!stationName) stationName = ConfigTypes.STATION;
    if (stationName) {
        if (elements && elements.length) {
            extraLane = elements.find(el => el.data && el.data.metadata && el.data.metadata.fields
                && el.data.metadata.fields.txt3 && el.data.metadata.fields.txt3 == stationName)
        }
        if (!extraLane) {
            extraLane = elements.find(el => el.data && el.data.metadata && el.data.metadata.fields
                && el.data.metadata.fields.title
                && el.data.metadata.fields.title.toLowerCase().includes(stationName))
        }
    }

    return extraLane;
}

//LANE TREE
export const getLaneWorks = (dispatch, res) => {
    const laneIds = [];
    const lanes = {};
    const laneTree = [];
    let elements = [];
    let noLanesData = true;
    let extraLane;
    console.log("LOGS: getLaneTreeSuccess res", res);
    if (res.children && res.children.length) {
        elements = res.children.map(item => {
            if (item && item.project && item.project.data && item.project.data.id) {
                return ({ ...item.project, children: item.children || [], id: +item.project.data.id })
            }
        })
        extraLane = getExtraLane({ elements });
        console.log("LOGS: extraLane", extraLane);

        if (ConfigTypes.USE_EXTRALANE == true) {
            if (extraLane) {
                elements = elements
                    .filter(element => !element.name.includes("ExtraLaneStation") || element.id == extraLane.id);
            }
        } else {
            if (extraLane) elements = elements.filter(element => element.id !== extraLane.id);
            elements = elements.filter(element => !element.name.includes("ExtraLaneStation"));
        }
    }

    if (elements.length > 0) {
        elements.forEach((item, index) => {
            laneIds.push(item.id);
            if (extraLane && item.id == extraLane.id) {
                item.isExtraLane = true;
            }
            laneTree.push(item);
            lanes[item.id] = [];
            let children = [];
            if (item.children && item.children.length) {
                item.children.forEach(el => {
                    if (el.project && el.project.data && el.project.data.id) {
                        children.push({ ...el.project, id: +el.project.data.id });
                        lanes[item.id].push(el.project.data.id);
                    }
                });
                item.children = children;
                noLanesData = false;
            }
        });
        console.log("LOGS: getLaneTreeSuccess elements", elements);
    }

    let trailerLane = ConfigTypes.USE_EXTRALANE == true ? extraLane : laneTree[0];
    dispatch(actions.updateMediaObjects({ laneTree, lanes, noLanesData, extraLane, trailerLane }));
}

export const getLaneTree = () => {
    return dispatch => {
        dispatch(actions.updateMediaObjects({ loading: true }));
        window.flow.distprojectGetFullTree('sdk_tvlane').then(res => {
            getLaneWorks(dispatch, res);
            setTimeout(() => dispatch(actions.updateMediaObjects({ loading: false })), 100);
        }).catch(err => {
            console.log("LOGS: getLaneTree ERROR", err);
            setTimeout(() => dispatch(actions.updateMediaObjects({ loading: false, noLanesData: true })), 100);
        });
    };
};

export const getFeDDOptions = (what) => {
    return async (dispatch) => {
        try {
            dispatch(actions.updateMediaObjects({ loading: true }));
            const res = await window.flow.sdkFeReGetDDOptions(what);
            console.log("LOGS: getFeDDOptions res=OK");
            if (res) {
                let tmp = Object.keys(res).map(i => res[i]);
                if (tmp && tmp.length) {
                    dispatch(actions.updateMediaObjects({ [what]: tmp }));
                }
            }
            dispatch(actions.updateMediaObjects({ loading: false }));
        } catch (error) {
            console.log("LOGS: Error in getFeDDOptions", error);
        }
    }
}


export const updateMediaObjectsSuccess = (data) => {
    return {
        type: actionTypes.MEDIA_UPDATE_MEDIAOBJECTS_SUCCESS,
        payload: data
    }
}

export const updateMediaObjects = (obj) => {
    return (dispatch) => {
        dispatch(actions.updateMediaObjectsSuccess(obj));
    }
}
